import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { DataGrid, GridColDef, GridRenderCellParams, GridSelectionModel } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { IAdminDataset, useAdminDatasetsQuery } from '../../api/admin';
import AdminQuickFilterToolbar from './AdminQuickFilterToolbar';
import GrantDatasetPermissionDialog from './GrantDatasetPermissionDialog';

export default function DatasetsTable() {
	const navigate = useNavigate();
	const { data: datasets, isLoading } = useAdminDatasetsQuery();

	const columns: GridColDef[] = [
		{ field: 'vendor_name', headerName: 'Vendor', flex: 1, minWidth: 120 },
		{ field: 'name', headerName: 'Dataset', flex: 1.2, minWidth: 140 },
		{
			field: 'internal_description',
			headerName: 'Internal Description',
			flex: 1,
		},
		{
			field: 'is_platform_included',
			headerName: 'Platform Included',
			flex: 1,
			type: 'boolean',
		},
		{
			field: 'actions',
			headerName: '',
			width: 48,
			sortable: false,
			filterable: false,
			disableColumnMenu: true,
			renderCell: (params: GridRenderCellParams) => (
				<Tooltip title="View permissioned users">
					<IconButton
						size="small"
						onClick={() =>
							navigate(`/admin/datasets/${params.row.id}/permissions`, {
								state: { datasetName: params.row.name, vendorName: params.row.vendor_name },
							})
						}
					>
						<PeopleOutlineIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			),
		},
	];

	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
	const [dialogOpen, setDialogOpen] = useState(false);

	const selectedDatasets: IAdminDataset[] = (datasets ?? []).filter((ds) =>
		selectionModel.includes(ds.id)
	);

	return (
		<Box sx={{ height: 'calc(100vh - 200px)', minHeight: 400 }}>
			{selectionModel.length > 0 && (
				<Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
					<Button
						variant="contained"
						size="small"
						startIcon={<LockOpenIcon />}
						onClick={() => setDialogOpen(true)}
					>
						Grant {selectionModel.length} Dataset{selectionModel.length !== 1 ? 's' : ''} to Users
					</Button>
				</Box>
			)}
			<DataGrid
				rows={datasets ?? []}
				columns={columns}
				loading={isLoading}
				density="compact"
				checkboxSelection
				disableSelectionOnClick
				selectionModel={selectionModel}
				onSelectionModelChange={setSelectionModel}
				components={{ Toolbar: AdminQuickFilterToolbar }}
				componentsProps={{ toolbar: { showQuickFilter: true } }}
			/>
			<GrantDatasetPermissionDialog
				open={dialogOpen}
				onClose={() => {
					setDialogOpen(false);
					setSelectionModel([]);
				}}
				datasets={selectedDatasets}
			/>
		</Box>
	);
}
